import gql from 'graphql-tag';

export const SELECTED_INSURANCE = gql`
    query getSelectedInsuranceForProviderLocation($directoryId: String!, $providerId: String!, $locationId: String!, $carrierId: String!, $planId: String!) {
        provider(id: $providerId, directoryId: $directoryId) {
            selectedInsurance(locationId: $locationId, carrierId: $carrierId, planId: $planId) {
                properties {
                    key
                    value
                }
            }
        }
    }
`;
